import ImageGallery from './ImageGallery';
import { Link } from 'react-router-dom';

import 'styles/BugReportList.css';

export default function BugReportList({bugReports, showCreator = false, noReportsMessage}) {
  return (
    <div className="reports">
      {
        (!bugReports || bugReports.length === 0) &&
        <div className="no-reports">{noReportsMessage}</div>
      }
      {[...(bugReports || [])]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map(bugReport => <BugReportCard bugReport={bugReport} key={bugReport.id} showCreator={showCreator} />)
      }
    </div>
  )
}

export function BugReportCard({bugReport, showCreator = false}) {
    return (
      <div className="bug-report-card" key={bugReport.id}>
      <div className={"header" +  (bugReport.creator ? ' show-creator' : '')}>
          <div className="title">{bugReport.title}</div>
          <div className={`status ${bugReport.status}`}>{bugReport.status}</div>
          {
            showCreator && bugReport.creator &&
            <div className="creator">
                <Link to={"/u/"+bugReport.creator.username} style={ {color: "rgb(48, 40, 158)", textDecoration: 'none', fontWeight: "bold"} }>
                {bugReport.creator.name}
                </Link>
            </div>
          }
      </div>
      <div className="body">
          <div className="description">{bugReport.description}</div>
          <div className="importance">
          <span className="label">Importance:</span>
          <span className="value">
              <div className="bar" style={{
              width: `${bugReport.criticality}%`,
              backgroundColor: `hsl(${120 - bugReport.criticality * 1.2}, 100%, 45%)`
              }} />
          </span>
          </div>
          <div className="images">
            <div className="label">Images:</div>
            <ImageGallery images={bugReport?.images.map(image => ({id: image.id, url: image.imageSrc}))} />
          </div>
          {
            showCreator && bugReport.creator &&
            <div className="created-at">
              <span className="label">Created at: </span>
              <span className="value">{new Date(bugReport.createdAt).toLocaleString()}</span>
            </div>
          }
      </div>
      </div>
    );
  }